var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogosTrello(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 66,
    viewBox: "0 0 74 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_59)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.7734 0H7.22656C3.23544 0 0 2.88566 0 6.44531V59.5547C0 63.1143 3.23544 66 7.22656 66H66.7734C70.7646 66 74 63.1143 74 59.5547V6.44531C74 2.88566 70.7646 0 66.7734 0Z",
    fill: "url(#paint0_linear_2_59)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9112 8.58H45.2787C43.363 8.58 41.81 9.96512 41.81 11.6738V34.3613C41.81 36.0699 43.363 37.455 45.2787 37.455H60.9112C62.827 37.455 64.38 36.0699 64.38 34.3613V11.6738C64.38 9.96512 62.827 8.58 60.9112 8.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7212 8.58H13.0887C11.173 8.58 9.62 9.96512 9.62 11.6738V50.8613C9.62 52.5699 11.173 53.955 13.0887 53.955H28.7212C30.637 53.955 32.19 52.5699 32.19 50.8613V11.6738C32.19 9.96512 30.637 8.58 28.7212 8.58Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_59",
    x1: 3700,
    y1: 0,
    x2: 3700,
    y2: 6600,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0091E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0079BF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_59"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 66,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosTrello);
export default __webpack_public_path__ + "static/media/logos_trello.ec3e9cbc3ca6446bd117e9509d7e2d30.svg";
export { ForwardRef as ReactComponent };